/*
 * @Author: Hong.Zhang
 * @Date: 2021-11-02 17:46:17
 * @Description: 
 */
export const Fonts = {
  tiny: 12,
  small: 14,
  medium: 16,
}